import React from "react";
import { CommonProps } from "@front/fds2.0-green/dist/src/helpers/props";
import classNames from "classnames";
import "./index.scss";

export interface IProps extends CommonProps {
  width?: string | number | undefined;
  height?: string | number | undefined;
  direction?: "left" | "right";
  onClick?: any;
}
const CardDirectionIcon: React.FC<IProps> = ({
  classes,
  width,
  height,
  direction = "left",
  onClick,
}) => {
  return (
    <div
      className="cardDir"
      style={{ height: height ?? "32px" }}
      onClick={onClick}
    >
      {direction === "left" ? (
        <svg
          width={width || "32"}
          height={height || "32"}
          className={classNames(classes, "")}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="16"
            cy="16"
            r="15.5"
            transform="rotate(-180 16 16)"
            fill="white"
            stroke="#D1D6DB"
          />
          <path
            d="M18 12L14 16L18 20"
            stroke="#252D38"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          width={width || "32"}
          height={height || "32"}
          viewBox="0 0 32 32"
          className={classNames(classes, "")}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="15.5" fill="white" stroke="#D1D6DB" />
          <path
            d="M14 20L18 16L14 12"
            stroke="#252D38"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </div>
  );
};

export default CardDirectionIcon;
